<template>
    <form class="modal-card">
        <!-- <header class="modal-card-head">
            <p class="modal-card-title">
                Create New Project
            </p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
        </header> -->
        <section class="modal-card-body">
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
            </b-loading>

    
            <h2 class="title is-2">
                Retrain AI Model
            </h2>
            <!-- <div class="block">
                Model needs example data (text and labels), which can be uploaded as files in the .csv format and should have at least one column for <b>text</b>.
                <br><br>
                For the <b>label</b> information, you can select the labels as a column in the file or you can use our <b>data labeling tool</b> to annotate your data.
            </div> -->
            <!--b-field label="">
                
                <a class="is-link is-small" href="https://firebasestorage.googleapis.com/v0/b/ml-saas.appspot.com/o/datasets%2F5p6YeUwjRr8Wlt5fAbFX%2Fbanking77_curated.csv">
                Click here to download a demo csv file
                </a>
                
            </b-field-->
            <b-field label="Speed">
                <b-slider :min="0" :max="3" aria-label="Fan" :tooltip="false" disabled>
                    <b-slider-tick :value="1">Low</b-slider-tick>
                    <b-slider-tick :value="2">High</b-slider-tick>
                    <b-slider-tick :value="3">Auto</b-slider-tick>
                </b-slider>
            </b-field>
            <div class="block">
                <b-radio v-model="radio"
                    name="name"
                    native-value="Slow">
                    Slow
                </b-radio>
                <b-radio v-model="radio"
                    name="name"
                    native-value="Medium">
                    Medium
                </b-radio>
                <b-radio v-model="radio"
                    name="name"
                    native-value="Fast">
                    Fast
                </b-radio>
            </div>

            <b-switch>Hyperparameter search optimization</b-switch>

            <b-field label="PRO plan options" grouped>
                <b-switch>Expert review</b-switch>
            </b-field>
            
            <br>
            

            <b-field label="Project name">
                <b-input
                    type="text"
                    v-model="projectName"
                    placeholder="Dataset name"
                    required>
                </b-input>
            </b-field>
            
    
            <b-field label="AI Engine">
                <b-radio-button v-model="radioButton"
                    native-value="classify"
                    size="is-large"
                    type="is-info">
                    <span>Classification</span>
                </b-radio-button>

                <b-radio-button v-model="radioButton"
                    native-value="entity"
                    size="is-large"
                    type="is-info">
                    <span>Entity Recognition</span>
                </b-radio-button>

                <b-radio-button v-model="radioButton"
                    rounded
                    native-value="search"
                    size="is-large"
                    type="is-info">
                    <span>Search</span>
                </b-radio-button>
                
            </b-field>
            
            <b-message v-if="radioButton" :title="engines[radioButton].description" size="is-medium" type="is-info" :closable="false">
                
                
                <!-- description() }} -->
            </b-message>
            <b-message v-else size="is-medium" type="is-info" :closable="false">
                Choose one
            </b-message>

            

            <b-field label="Require a PRO plan" v-if="radioButton != false && radioButton != 'classify'">
                <h2 class="subtitle is-4">
                    {{ engines[radioButton].title }} requires a paid plan. Upgrade your plan to enable OCR for your account.
                </h2>
                
            </b-field>
            <!-- <div v-if="radioButton == 'classify'">
                
                    
                <b-field label="Add labels">
                        <b-field grouped>
                            <b-input placeholder="Label"
                                v-model="adding_label"
                                @input="addLabels()"
                                type="input">
                            </b-input>
                        </b-field>
                    
                </b-field>

                <p class="content"><b>Labels:</b> 
                    <b-tag type="is-primary"
                    
                    aria-close-label="Delete label"
                    closable v-for="label in labels">
                    {{ label }}
                    </b-tag>
                </p>
            </div> -->

        </section>
        <footer class="modal-card-foot">
            <b-button
                label="Close"
                @click="$emit('close')" />
            <b-button
                tag="button"
                native-type="submit"
                label="Retrain"
                type="is-info"
                expanded 
                :disabled="radioButton != 'classify'"/>
        </footer>
    </form>
    </template>
    <script>
    import { uuid } from 'vue-uuid'; 
    
    
    import Papa from 'papaparse';
    import DataFrame from 'dataframe-js';
    
    export default {
      components: {  },
      data() {
        return {
            labels: [],
            adding_label: undefined,
            readyToCreate: false,
            isLoading: false,
            projectId: false,
            projectName: null,
            settings: {
                readOnly: true,
                rowHeaders: true,
                licenseKey: 'non-commercial-and-evaluation'
            },
            radioButton: false,
            sampleDataframe: false,
            datasetName: '',
            isFinished: false,
            selectedDataset: ['A'],
            csv: null,
            label_col: false,
            text_col: false,
            animated: true,
            imageData: null,
            file2: false,
            picture: null,
            files: [],
            uploadValue: 0,
            csv: 1,
            json: 1,
            previewDataset: null,
            isComponentModalActive: false,
            isComponentDatasetEditActive: false,
            engines: {
                "classify": 
                {
                    "title": "Text Classification", 
                    "description": "Build a text classification model to categorize text using labels you provide."
                },
                "entity": {
                    "title": "Entity Recognition", 
                    "description": "Build a entity recognition model to identify entities in the text using entities you provide."
                },
                "search": {
                    "title": "Semantic Search",
                    "description": "Build a semantic search model to search in a set of text samples you provide.", 
                    
                }
            }
        };
      },
      created() {
        this.$store.dispatch("currentUser");
      },
      computed: {
        currentUser() {
          return this.$store.state.currentUser;
        },
        plans() {
            return this.$store.state.plans
        }
        // datasets() {
        //     return this.$store.state.datasets
        // }
      },
      methods:{
        addLabels(){
            if (this.adding_label != undefined) {
                this.labels.push(this.adding_label)
            }
            this.adding_label = undefined
        },
        title(){
            try {
                return this.engines[this.radioButton].title
            } catch {
                return false
            }
            
        },
        description(){
            try {
                return this.engines[this.radioButton].description
            } catch {
                return false
            }
        },
        retrainModel(){
            this.isLoading = true
            // Checking your data. This may take up to one minute, depending on the size of your file.
            // Uploading your file. This may take up to a few minutes, depending on your connection speed.
    
            
            
        },
        completeConfirm(){
            this.isLoading = false
            this.$buefy.dialog.confirm({
                        message: `Great! Project created.\n\nThe next page you will add the data and train AI models`,
                        onConfirm: () => this.redirect(this.projectId) 
            })
        },
        openLoading() {
                let isFullPage = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.element.$el
                })
                setTimeout(() => loadingComponent.close(), 3 * 1000)
        },
        redirect(projectId){
    
                this.$buefy.toast.open('Opening new project')
                
                
                setTimeout(() => 
                this.$router.push(`/projects/${projectId}/uploads`), 
                3 * 1000)
                
        },
      }
        
    }
    </script>